import script from "./AssetManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetManage.vue?vue&type=script&setup=true&lang=js"

import "./AssetManage.vue?vue&type=style&index=0&id=4d19748f&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d19748f"]])

export default __exports__